import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../../shared/shared.module';
import {CrmFeatureGuard} from '../../../core/guards/crm-feature.guard';
import {PhoneGuard} from '../../../core/guards/phone.guard';
@NgModule({
    declarations: [],
    imports: [
        CommonModule, IonicModule, SharedModule,
        RouterModule.forChild([
            {
                /**
                 *  should add child module in app.module.ts to make it work
                 * */
                path: 'member-reward-court',
                canLoad: [CrmFeatureGuard],
                loadChildren: './member-reward-court/member-reward-court.module#MemberRewardCourtModule',
                data: {preload: true, delay: false}
            },
            {
                /**
                 *  should add child module in app.module.ts to make it work
                 * */
                path: 'reward-list',
                canLoad: [CrmFeatureGuard],
                loadChildren: '../reward-list/reward-list.module#RewardListModule',
            },
            {
                /**
                 *  should add child module in app.module.ts to make it work
                 * */
                path: 'login-court',
                loadChildren: './login-court/login-court.module#LoginCourtModule',
            },
            {

                path: 'verify-registration-court',
                canLoad: [CrmFeatureGuard],
                loadChildren: './verify-registration-court/verify-registration-court.module#VerifyRegistrationCourtModule',
            },
            {

                path: 'reset-password-court',
                canLoad: [CrmFeatureGuard],
                loadChildren: './reset-password-court/reset-password-court.module#ResetPasswordCourtModule',
            },
            {
                path: 'registration-court',
                canLoad: [CrmFeatureGuard],
                canActivate: [PhoneGuard],
                loadChildren: './registration-court/registration-court.module#RegistrationCourtModule'
            },
             {
                /**
                 *  should add child module in app.module.ts to make it work
                 * */
                path: 'profile-court',
                canLoad: [CrmFeatureGuard],
                loadChildren: './profile-court/profile-court.module#ProfileCourtModule',
            }

        ])
    ]
})
export class MemberCourtRouteModule {
}
